import "./MeetingEducationBanner.scss";

import { Button, Flex, Text, VideoCameraEmphasisIcon } from "@fluentui/react-northstar";
import React, { useState } from "react";

import { useUserInfo } from "../../actions/useUserInfo";
import { clientEventTracker } from "../../utils/clientTelemetry";

export const MeetingEducationBanner: React.FC = () => {
  const [isExpanded, setIsExpanded] = useState<boolean | undefined>();
  const { user } = useUserInfo();

  if (!user.featureFlags.meetingEducationBanner) {
    return null;
  }

  return (
    <Flex
      column
      className={`meeting-education ${isExpanded ? "meeting-education-expanded" : ""}`}
      onClick={() => setIsExpanded(!isExpanded)}
    >
      <Flex>
        <Flex.Item grow>
          <Flex
            className="meeting-education__click-banner"
            vAlign="center"
            hAlign="center"
            gap="gap.small"
            onClick={() => {
              if (!isExpanded) {
                clientEventTracker.track("meeting banner expand", user, {});
              }
              setIsExpanded(!isExpanded);
            }}
          >
            <VideoCameraEmphasisIcon size="small" />
            <Text content="Have you tried Polly in your meetings?" />
            <Text content="Learn More!" weight="bold" />
          </Flex>
        </Flex.Item>
      </Flex>
      {isExpanded && (
        <Flex column gap="gap.small" hAlign="stretch" style={{ padding: "1rem" }}>
          <Text
            align="center"
            size="medium"
            content="Use Polly's new enhanced meeting experience directly in your meeting for a better experience!"
          />

          <iframe
            title="Polly for Meetings"
            height="350"
            src="https://www.youtube.com/embed/7PK05mlvKTg?rel=0"
            frameBorder={0}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />

          <Button
            text
            fluid
            content={
              <Text
                content="🔗 Learn how to add Polly to your Microsoft Teams meeting!"
                className="meeting-education__learn-more-button"
              />
            }
            primary
            onClick={() => {
              window.open(
                "https://www.polly.ai/help/microsoft-teams/polly-for-teams-meetings-guide",
                "_blank"
              );
            }}
          />
        </Flex>
      )}
    </Flex>
  );
};
